/**
 * 最新热文
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import ShanklistComponents from '../../../../components/shanklistComponents/index';
import { classnames } from '../../../../utils/classnames';
import { rel as relText } from '../../../../utils/rel';
import { formatImage, formatUrl } from '@ifeng/public_method';
import { handleAd } from '../../../../utils/handleAd';
import { addEventListener, Event as UiBaseEvent } from '@ifeng/ui_base';

class FocusImgNews extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        ad: PropTypes.object,
    };
    state = {
        content: this.props.content, // 文章列表
    };
    // 获取image的url
    getImageUrl(item) {
        if ('picUrl' in item) {
            return item.picUrl;
        } else {
            return item.url;
        }
    }
    constructor(...argv) {
        super(...argv);

        this.event = new UiBaseEvent();

        this.state = {
            content: this.props.content, // 文章列表
        };
    }
    async componentDidMount() {
        // 插入广告
        if (this.props.ad) {
            await this.getAd(this.props.ad);
        }
    }
    // 获取广告
    async getAd(ad) {
        const len = this.state.content.length;
        const callback = await handleAd(ad);

        callback(ad.data, this.event, this.insert);

        this.event.trigger('init', { len: len < 3 ? len : 3, index: 0 });
    }
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { content } = this.state;

            const infoData = [...content];

            const refs = [];

            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            this.setState({ content: infoData }, () => {
                const dom = {};

                for (const ref of refs) {
                    dom[ref.index] = ref.ref.current;
                }
                adFn(dom);
            });
        }
    };

    render() {
        const { content } = this.state;

        return (
            <div className={styles.rank_group}>
                <div className={styles.v2columu_fc}>
                    <div className={styles.v2columu_fc_r1}>
                        <a href={content[0].url} target="_blank" className={styles.img}>
                            <img
                                src={
                                    content[0].thumbnails.image && content[0].thumbnails.image.length >= 1
                                        ? formatImage(this.getImageUrl(content[0].thumbnails.image[0]), 417, 206)
                                        : undefined
                                }
                            />
                        </a>
                        <div className={styles.txt}>
                            <a href={content[0].url} target="_blank">
                                <h2 className={styles.tit}>{content[0].title}</h2>
                            </a>
                        </div>
                    </div>

                    <div className={styles.v2columu_fc_r2}>
                        <a href={content[1].url} target="_blank" className={styles.l1}>
                            <h2 className={styles.tit}>{content[1].title}</h2>
                        </a>
                        {content[2] && content[2].type === 'ad' ? (
                            <div ref={content[2].ref} className={styles.ad} />
                        ) : (
                            <a href={content[2].url} target="_blank" className={styles.l2}>
                                <h2 className={styles.tit}>{content[2].title}</h2>
                                <div className={styles.l3}>
                                    <img
                                        src={
                                            content[2].thumbnails.image && content[2].thumbnails.image.length >= 1
                                                ? formatImage(
                                                      this.getImageUrl(content[2].thumbnails.image[0]),
                                                      189,
                                                      125,
                                                  )
                                                : undefined
                                        }
                                    />
                                </div>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export { FocusImgNews };
export default FocusImgNews;
